import React from 'react';
import classes from './style.module.css'
import Aux from 'react-aux'

const WinnerBox = props => {

    let style = {
        backgroundColor: 'lightgreen'
    }

    if(props.type === "P") {
        style = {
            backgroundColor: 'lightblue'
        }
    }

    const tickBox = <div style={style} className={classes.WinnerBox}>
            {props.type}
    </div>

   return (
       <Aux>
       {tickBox}
       </Aux>
   );
}

export default WinnerBox;